export default __webpack_public_path__ + "static/media/Icons_Arrows_Norgie_Down_Bold.be61dead.svg";